import React, { useEffect } from "react";

import { Route, Switch, useLocation } from "react-router-dom";
import { AppLoaderContainer } from "./containers/AppLoaderContainer";
import { NotFoundContainer } from "./containers/NotFoundContainer";
import { LoginContainer } from "./containers/LoginContainer";
import ReactGA from "react-ga4";
import { usePageTrackingGA, useCpfHash } from "./hooks";
import { AppMessageListener } from "./containers/AppMessageListener";
import { isBrowser } from "./util/env-utils";
import { TitleUpdater } from "./components/Header/TitleUpdater";
import { ChatContainer } from "./modules/chat/chat.container";
import { RedirectSsoLoginPageContainer } from "./containers/RedirectSsoLoginPageContainer";
import { PrivacyPoliciesPage } from "./components/PrivacyPoliciesPage/PrivacyPoliciesPage";
import { RedirectTriggerPageContainer } from "./containers/redirect-trigger-page.container";
import { useKeycloak } from "@react-keycloak/ssr";
import type { KeycloakInstance } from "keycloak-js";

const App = () => {
  // GA Tracking
  const location = useLocation();
  const { keycloak, initialized } = useKeycloak<KeycloakInstance>();

  useEffect(() => {
    const googleAnalyticsId = isBrowser
      ? window?.GOOGLE_ANALYTICS_ID
      : undefined;
    if (!googleAnalyticsId) return;
    ReactGA.initialize(googleAnalyticsId);
  }, []);

  const hashUserCpf = useCpfHash(
    initialized ? keycloak?.token : undefined,
    keycloak?.authenticated
  );

  const userStatus = initialized
    ? keycloak?.authenticated
      ? "authenticated"
      : "anonymous"
    : undefined;

  usePageTrackingGA({ ...location, userStatus, hashUserCpf });

  return (
    <>
      <LoginContainer>
        <TitleUpdater />
        <AppMessageListener />
        <Switch>
          <Route path={"/app"}>
            <AppLoaderContainer />
          </Route>
          <Route exact={true} path="/">
            <AppLoaderContainer slug={"catalog"} />
          </Route>
          <Route exact={true} path="/require-login">
            <RedirectSsoLoginPageContainer />
          </Route>
          <Route exact={true} path="/redirect">
            <RedirectTriggerPageContainer />
          </Route>
          <Route exact={true} path="/politicas-de-privacidade">
            <PrivacyPoliciesPage />
          </Route>
          <Route path="*">
            <NotFoundContainer />
          </Route>
        </Switch>
      </LoginContainer>
      <ChatContainer />
    </>
  );
};

export default App;
